import { ActionHandler } from "..";
import {
  getEligibleMedProductsPlanSelection,
  MED_FLOW,
} from "src/utils/medEligibility";
import {
  getHRTRecommendedPlanTier,
  getMedRecommendedPlanTier,
} from "src/components/med/planInformation/utils";
import { setRecommendationContext } from "src/utils/redux/slices/recommendationContext";
import { queryRecommendedBuyflowOffers } from "src/api/recommendedOffers";
import { isClinicalRoute } from "src/utils/userSegment";
import { captureException } from "src/utils/error";

export const setRecommendedMedPlans: ActionHandler = async ({
  params,
  store,
}) => {
  // For now, we're just going to query the recommended buyflow offers.
  // In the future, we'll want to store the recommended buyflow offers in the
  // redux store and use them to populate the med plan selection page.
  if (isClinicalRoute()) {
    try {
      await queryRecommendedBuyflowOffers();
    } catch (error) {
      console.error("Error querying recommended buyflow offers", error);
      captureException(error, "setRecommendedMedPlans");
    }
  }

  const { flow } = params;

  const recommendedMedTier =
    flow === MED_FLOW.HRT
      ? getHRTRecommendedPlanTier()
      : getMedRecommendedPlanTier();

  store.dispatch(
    setRecommendationContext({
      recommendedMedTier,
      eligibleMedTiers: getEligibleMedProductsPlanSelection(recommendedMedTier),
      flow,
    })
  );
};
